import { ImportSourceFacebook } from './facebook';
import { ImportSourceGoogle } from './google';

function getAdaptedRepository(propMapping, repo) {
  function AdaptedRepository() {}
  AdaptedRepository.prototype = repo;
  const adaptedRepo = new AdaptedRepository();
  Object.keys(propMapping).forEach((newPropName) => {
    const propName = propMapping[newPropName];
    adaptedRepo[newPropName] = repo[propName];
  });
  return adaptedRepo;
}

function geti18nWrapper(i18n, getI18nString) {
  function I18nWrapper() {
    this.get = (key, ...args) => getI18nString(i18n, 'get', key, args);
    this.getString = (key, ...args) => getI18nString(i18n, 'getString', key, args);
  }
  I18nWrapper.prototype = i18n;
  const newI18n = new I18nWrapper();
  return newI18n;
}

const getImportSource = (source, i18n, repository) => {
  const {
    name,
    getI18nString,
    getStateAdapter,
    repoPropMapping,
  } = source;
  const i18nWrapper = geti18nWrapper(i18n, getI18nString);
  return {
    name,
    i18n: i18nWrapper,
    getStateAdapter,
    repository: repository ? getAdaptedRepository(repoPropMapping, repository) : null,
  };
};

export const ImportSource = {
  facebook: (i18n, repository) => getImportSource(ImportSourceFacebook, i18n, repository),
  google: (i18n, repository) => getImportSource(ImportSourceGoogle, i18n, repository),
};
